import React from "react";

import { arrayOf, func, number, object } from "prop-types";

import { Button } from "../../../../common";
import * as style from "./styles.module.scss";

const displayAddress = (address) =>
  address.formatted_address
    .filter((addressPart) => addressPart !== "")
    .join(", ");

const AddressSelectList = ({
  addresses,
  onAddressSelect,
  selectedIndex,
  showAddressOnSelect = false,
  showManualAddressFunc = () => {},
}) => (
  <div style={{ maxHeight: 180, overflowY: "scroll" }}>
    <div className="text-left ">
      {addresses.map((address, index) => (
        <Button
          key={index}
          classes={`register_field list-group-item-action
            ${style.addresslist__listItem}
            ${
              selectedIndex === index
                ? `${style.addressSelected} text-white`
                : ""
            }`}
          onClick={(e) => {
            e.preventDefault();
            onAddressSelect(index);
            if (showAddressOnSelect) {
              showManualAddressFunc();
            }
          }}
        >
          {displayAddress(address)}
        </Button>
      ))}
    </div>
  </div>
);

AddressSelectList.propTypes = {
  addresses: arrayOf(object),
  onAddressSelect: func.isRequired,
  selectedIndex: number.isRequired,
};

export default AddressSelectList;
